<template>
  <div
    class="form-select control-group"
    :class="{ error: error }"
  >
    <label
      class="control-label"
      :for="name"
    >
      <abbr
        v-if="required"
        title="Verplicht veld"
      >
        *
      </abbr>
      {{ label }}
    </label>
    <select
      class="form-checkbox__options"
      :value="value"
      @change="v => $emit('input', v.target.value)"
    >
      <option :value="null" />
      <option
        v-for="option in optionsFromParent"
        :key="option"
      >
        {{ option }}
      </option>
    </select>
    <span
      v-if="error && error.input"
      class="help-inline"
    >
      {{ error.input }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'FormSelect',

  schema: [
    {
      name: 'label',
      default: 'Label',
      type: 'FormText',
      label: 'Label',
    },
    {
      name: 'options',
      default: [],
      type: 'FormChips',
      label: 'Opties',
    },
    {
      name: 'required',
      default: false,
      type: 'FormCheckbox',
      label: 'Verplicht',
    },
  ],

  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => ([]),
    },
    optionsFrom: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: () => (null),
    },
  },

  computed: {
    optionsFromParent() {
      if (!this.optionsFrom) return this.options;

      return this.$parent.value[this.optionsFrom];
    },
  },
};
</script>

<style lang="scss">
.form-select {
  display: flex;
  flex-grow: 1;

  label.control-label {
    width: 50%;
    font-size: 14px;
    line-height: 30px;
    margin-right: 20px;
    padding-left: 40px;
    text-align: left;
  }

  select {
    width: 50%;
    // margin-right: 10px;
  }
}
</style>
